import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { DashboardData } from "src/app/shared/models/dashboard.model";
import { RouteEnum } from "src/app/shared/models/routes.model";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { dashboardData } from "src/app/shared/ngrx/ngrx-selectors";
import {
  UI__ROUTE_NAVIGATION,
  UI__SIDEBAR_ROUTE_NAVIGATION,
} from "src/app/shared/ngrx/ngrx-actions";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "dash-order-summary",
  templateUrl: "./dash-order-summary.component.html",
  styleUrls: ["./dash-order-summary.component.scss"],
  imports: [TranslateModule, CommonModule],
  standalone: true,
})
export class DashOrderSummaryComponent implements OnInit {
  routeEnum: RouteEnum = new RouteEnum();

  get data(): DashboardData {
    return this.store.selectSignal(dashboardData)();
  }

  constructor(private readonly store: Store, private router: Router) {}

  ngOnInit(): void {}

  filterOrdersBySummaryCode(code: string) {
    this._dispatchInboxNavigation();

    this.router.navigate([this.routeEnum.URL_INBOX], {
      queryParams: { summaryCode: code, reuse: "false" },
    });
  }

  _dispatchInboxNavigation() {
    this.store.dispatch(
      UI__ROUTE_NAVIGATION({
        data: { link: this.routeEnum.URL_INBOX },
      })
    );

    this.store.dispatch(
      UI__SIDEBAR_ROUTE_NAVIGATION({
        data: { tabId: "inbox" },
      })
    );
  }
}
